import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Plan_Type_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_PLANM_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Plan Type WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    PLANM_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Plan Type Id', columnResourceName: 'colPlanTypeId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PLANM_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

var PlanTypeSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_PLANM_ID',
        id_ui: 'PLANM_ID',
        name:  'PLANM_NAME'},


    searchProviderFields: vUI_Plan_Type_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Plan_Type_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var PlanTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "PlanTypeSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'PLANM_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'PLANM_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'PLANM_ID','PLANM_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PlanTypeSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var PlanTypeSearch: ISearch = {
    searchName: "Find Plan Type",
    renderOptions: { ui5ResourceId: "PlanTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [PlanTypeSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("PlanTypeBO", "PlanType", PlanTypeSearch, "Plan Type Search")

export {PlanTypeSearch}